/**
 * Polyfill for Capacitor iOS to handle history API issues
 */

// Store the original replaceState
const originalReplaceState = window.history.replaceState;

// Override replaceState to handle errors gracefully on iOS
if (window.history && window.history.replaceState) {
  window.history.replaceState = function(...args: any[]) {
    try {
      return originalReplaceState.apply(window.history, args);
    } catch {
      // Silently catch the error on iOS WebView - DO NOT LOG to prevent infinite loop
      // The error is expected on iOS and logging it causes IPC throttling
      return;
    }
  };
}

// Also patch globalHistory if it exists
if ((window as any).globalHistory && (window as any).globalHistory.replaceState) {
  const originalGlobalReplaceState = (window as any).globalHistory.replaceState;
  (window as any).globalHistory.replaceState = function(...args: any[]) {
    try {
      return originalGlobalReplaceState.apply((window as any).globalHistory, args);
    } catch {
      // Silently catch the error on iOS WebView - DO NOT LOG to prevent infinite loop
      return;
    }
  };
}

export {};